
interface LocaleAttribute {
    locale: string;
}

export interface UserRepresentation {
    id?: string;
    username?: string;
    email?: string;
    firstName?: string;
    lastName?: string;
    attributes?: LocaleAttribute[]
}

export function UserRepresentationFromJSON(json: any): UserRepresentation {
    if((json === null) || (json === undefined)){
        return json;
    }

    return {
        'id': json['id'],
        'username': json['username'],
        'email': json['email'],
        'firstName': json['firstName'],
        'lastName': json['lastName'],
        'attributes': json['attributes']
    }
}

export function UserRepresentationToJSON(value?: UserRepresentation | null): any {
    if(value === undefined) {
        return undefined;
    }
    if(value === null){
        return null;
    }

    return {
        'id': value.id,
        'username': value.username,
        'email': value.email,
        'firstName': value.firstName,
        'lastName': value.lastName,
        'attributes': value.attributes
    }
}